var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Stack } from "@mui/material";
import { USER_PROFILE_DATA } from "../../../api/url";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { Close } from "@mui/icons-material";
import { JcKey } from "../services/jcEntity";
import { getFilterUrl, JobCardServiceType, ServiceAdvisorListApi, statusListGet, VehicleListApi } from "../services/JobCardApiCall";
import dayjs from "dayjs";
import { maxDays, validateFilterDuration } from "../../../utils/utils";
import { showNotification } from "../../../redux/commonSlice";
export var FilterJobCard = function (props) {
    var _userData$data, _userData$data2, _userData$data3;
    var onClose = props.onClose, state = props.state;
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var crud = useAppSelector(function (state) { return state.crud; });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var MaxDateRange = getLocalStorageItem(LOCAL_STORAGE_KEYS.DATE_FILTER_RESTRICTION);
    MaxDateRange = MaxDateRange ? Number(MaxDateRange.Value) : maxDays;
    var dispatch = useAppDispatch();
    var currUser = {
        FullName: "".concat(userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.GivenName, " ").concat(userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.FamilyName),
        IdentityId: userData === null || userData === void 0 || (_userData$data3 = userData.data) === null || _userData$data3 === void 0 ? void 0 : _userData$data3.IdentityId
    };
    var branches = [selectedBranch];
    var formData = [{
            type: FormItemTypes.Typography,
            name: 'title',
            label: 'Apply filters to table data',
            children: 'Filters',
            fontSize: 'xxl',
            fontWeight: 'strong',
            labelTypographyProps: {
                fontSize: 'base',
                fontWeight: 'normal'
            },
            containerProps: {
                display: 'flex',
                flexDirection: 'column-reverse'
            },
            columnSize: true
        }, {
            type: FormItemTypes.IconButton,
            name: 'cancelButton',
            children: /*#__PURE__*/ React.createElement(Close, {
                color: "secondary"
            }),
            color: 'secondary',
            size: 'small',
            columnSize: 0,
            onClick: function () {
                onClose({
                    disableChange: true
                });
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'FormContainer',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'BranchId',
                    label: 'Branch',
                    displayExpr: "OrganizationName",
                    valueExpr: "OrganizationId",
                    options: branches,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'RepairTypeId',
                    label: 'Service type',
                    displayExpr: "Name",
                    valueExpr: "id",
                    getListData: JobCardServiceType,
                    apiRequest: {
                        ModuleEntityId: "JobCard",
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    },
                    apiKey: JcKey.JcServiceType,
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Status',
                    label: 'Job card status',
                    displayExpr: "Name",
                    valueExpr: "Key",
                    multiple: true,
                    disableCloseOnSelect: true,
                    getListData: statusListGet,
                    apiRequest: {
                        SystemName: "JobCard"
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'ProductId',
                    label: 'Vehicle',
                    getListData: VehicleListApi,
                    apiRequest: {
                        SystemName: "Product",
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    },
                    value: null,
                    getOptionLabel: function (option) {
                        var _option$Name, _option$SkuCode;
                        return option !== null && option !== void 0 && option.Name && option !== null && option !== void 0 && option.SkuCode ? "".concat((_option$Name = option === null || option === void 0 ? void 0 : option.Name) !== null && _option$Name !== void 0 ? _option$Name : '', " (").concat((_option$SkuCode = option === null || option === void 0 ? void 0 : option.SkuCode) !== null && _option$SkuCode !== void 0 ? _option$SkuCode : '', ")") : option === null || option === void 0 ? void 0 : option.Name;
                    },
                    displayExpr: "Name",
                    valueExpr: "id",
                    columnSize: 12
                }, (state === null || state === void 0 ? void 0 : state.IdentityId) === "all" ? {
                    type: FormItemTypes.SearchSelect,
                    name: 'ServiceAdvisor',
                    label: 'Service advisor',
                    getListData: ServiceAdvisorListApi,
                    apiKey: JcKey.ServiceAdvisorList,
                    apiRequest: {
                        BranchId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    },
                    valueExpr: "IdentityId",
                    displayExpr: "FirstName",
                    getOptionLabel: function (option) { return "".concat(option === null || option === void 0 ? void 0 : option.FirstName, " ").concat(option === null || option === void 0 ? void 0 : option.FamilyName); },
                    value: null,
                    columnSize: 12,
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: FormItemTypes.SearchSelect,
                            disabled: !(formValues !== null && formValues !== void 0 && formValues.BranchId)
                        };
                    }
                } : {
                    type: FormItemTypes.TextInput,
                    name: 'CurrentUser',
                    label: 'Service Advisor',
                    disabled: true,
                    value: currUser.FullName,
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'JcDate',
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.DatePicker,
                            name: 'FromDate',
                            label: 'Date range',
                            placeholder: "From date",
                            columnSize: 12,
                            timezone: 'system',
                            setFormState: function () {
                                return {
                                    ToDate: null
                                };
                            }
                            // validator(value, state) {
                            //     if (value && !dayjs(value).isValid()) return 'Enter valid date'
                            //     return ''
                            // },
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'ToDate',
                            columnSize: 12,
                            timezone: 'system',
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    minDate: dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.FromDate),
                                    maxDate: dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.FromDate).add(MaxDateRange, 'day'),
                                    disabled: !(formValues !== null && formValues !== void 0 && formValues.FromDate),
                                    required: Boolean(formValues === null || formValues === void 0 ? void 0 : formValues.FromDate),
                                    placeholder: formValues !== null && formValues !== void 0 && formValues.FromDate ? "To date *" : "To date"
                                };
                            }
                            // validator(value, state) {
                            //     if (state?.FromDate && !value) return 'This field is required'
                            //     if (value) {
                            //         if (!dayjs(value).isValid()) return 'Enter valid date'
                            //         if (dayjs(state?.FromDate).isAfter(dayjs(value))) return 'To date cannot be less than from date'
                            //         if (!validateFilterDuration(dayjs(state?.FromDate), dayjs(state?.ToDate))) return `The maximum allowed duration for the filter is ${MaxDateRange} days.`
                            //     }
                            //     return ''
                            // },
                        }],
                    columnSize: 12
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            spacing: 0,
            sx: {
                bottom: 0,
                justifyContent: 'space-between',
                backgroundColor: 'white',
                width: {
                    xs: '100%',
                    sm: '400px'
                },
                position: 'fixed',
                right: 0,
                zIndex: 2,
                py: 2.5,
                px: 3,
                borderTop: "1px solid",
                borderColor: 'secondary.200'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Reset',
                    color: 'secondary',
                    id: "discard",
                    columnSize: 0,
                    onClick: function () {
                        return 'reset';
                    },
                    variant: 'outlined',
                    setFormState: function (state) {
                        return {
                            ToDate: null,
                            FromDate: null,
                            BranchId: null,
                            RepairTypeId: null,
                            Status: null,
                            ProductId: null,
                            ServiceAdvisor: (state === null || state === void 0 ? void 0 : state.IdentityId) === "all" ? undefined : currUser.IdentityId
                        };
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    spacing: 0,
                    gap: '10px',
                    columnSize: 6,
                    sx: {
                        justifyContent: 'end'
                    },
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'Cancel',
                            children: 'Cancel',
                            variant: "outlined",
                            color: 'secondary',
                            onClick: function () {
                                onClose({
                                    disableChange: true
                                });
                            },
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Apply',
                            children: 'Apply',
                            variant: "contained",
                            onClick: function (e, formValues) {
                                if (formValues !== null && formValues !== void 0 && formValues.FromDate || formValues !== null && formValues !== void 0 && formValues.ToDate) {
                                    var _dayjs;
                                    if (!dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.FromDate).isValid() || !((_dayjs = dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.ToDate)) !== null && _dayjs !== void 0 && _dayjs.isValid())) {
                                        dispatch(showNotification({
                                            isOpen: true,
                                            message: "Please enter valid dates.",
                                            type: "error"
                                        }));
                                        return;
                                    }
                                    if (dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.FromDate).isAfter(dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.ToDate))) {
                                        dispatch(showNotification({
                                            isOpen: true,
                                            message: "From Date cannot be greater than To Date. Please enter valid dates.",
                                            type: "error"
                                        }));
                                        return;
                                    }
                                    if (!validateFilterDuration(dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.FromDate), dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.ToDate))) {
                                        dispatch(showNotification({
                                            isOpen: true,
                                            message: "The maximum allowed duration for the filter is ".concat(MaxDateRange, " days."),
                                            type: "error"
                                        }));
                                        return;
                                    }
                                }
                                onClose(formValues);
                                // return 'submit'
                            },
                            columnSize: 0
                        }]
                }],
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(Stack, {
        position: 'relative'
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        formProps: {
            px: 3,
            pb: 12,
            pt: {
                xs: 3,
                sm: 3,
                md: 11
            }
        },
        getFormAPI: getFilterUrl,
        getRequest: state,
        updateFormAPI: function (_ref) { return __awaiter(void 0, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = _ref.request;
                onClose(request);
                return [2 /*return*/, {
                        success: true
                    }];
            });
        }); }
    }));
};
